import { useState } from "react";

export type StatsProps = {
    statsData: StatsData[];
    isVisible: boolean;
};

export type StatsData = {
    icon: React.ElementType;
    value: string | number;
    label: string;
    bgColor: string;
    color: string;
};

const Stats = (
    props:{
    statsData: StatsData[];
    isVisible: boolean;
}
) => {

    const { statsData, isVisible } = props;

    const [hoveredCard, setHoveredCard] = useState<number>();

    return (
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 transform transition-all duration-1000 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          {statsData.map((stat, index) => (
            <div
              key={index}
              className={`${stat.bgColor} rounded-2xl p-6 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 border border-white/50`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(undefined)}
            >
              <div className="flex items-center gap-4">
                <div className={`p-3 rounded-xl bg-gradient-to-r ${stat.color} shadow-lg ${hoveredCard === index ? 'animate-pulse' : ''}`}>
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-3xl font-bold text-slate-800">{stat.value}</div>
                  <div className="text-slate-600 font-medium">{stat.label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
    )

}

export default Stats;